<template>
  <div id="form-input">
    <!-- Pull up their data, with an add button -->
    <!-- table of students -->
    <b-container fluid>
      <b-row class="mt-4" align-h="center">
        <div id="alerts" ref="school-students-alert">
          <b-alert
            :show="dismissCountDown"
            dismissible
            variant="success"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged"
            >You have successfully saved form data for all students!</b-alert
          >
          <b-alert
            :show="dismissCountDownError"
            dismissible
            variant="warning"
            @dismissed="dismissCountDownError = 0"
            @dismiss-count-down="countDownChangedError"
          >
            {{ errorMessage }}
          </b-alert>
        </div>
      </b-row>
      <b-row class="mt-4" align-h="center">
        <b-col>
          <b-form-group
            label="Starting Year: "
            label-for="year"
            label-cols-md="auto"
            class="mb-3"
          >
            <b-form-select
              id="year"
              v-model="startYear"
              :options="years"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Date of Form: "
            label-for="formDate"
            label-cols-md="auto"
            class="mb-3"
          >
            <b-form-input
              name="formDate"
              type="date"
              id="formDate"
              v-model="formDate"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Trainer: "
            label-for="trainer"
            label-cols-md="auto"
            class="mb-3"
          >
            <b-form-select
              name="trainer"
              :options="schoolTrainers"
              value-field="uuid"
              text-field="name"
              v-model="trainerUuid"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <div v-if="loadingStudents">
        <b-spinner></b-spinner>
      </div>
      <div v-else-if="schoolStudents && schoolStudents.length > 0">
        <b-row>
          <b-col>
            <table class="form-table">
              <tr>
                <th v-for="header in tableHeadersI" :key="header">
                  {{ header }}
                </th>
              </tr>
              <tr
                v-for="(student, i) in schoolStudents"
                :key="i"
                :class="{ disabled: !student.hasFormData }"
              >
                <td><input type="checkbox" v-model="student.hasFormData" /></td>
                <td>
                  <b-link
                    @click.stop="stopClick"
                    :to="{
                      name: 'EditStudent',
                      params: { id: student.student_uuid },
                    }"
                  >
                    {{ student.first_name }} {{ student.last_name }}
                  </b-link>
                </td>
                <td>{{ student.birthdate.split("T")[0] }}</td>
                <td>
                  <input
                    v-if="student.hasFormData"
                    type="number"
                    v-model="attendance[i]"
                  />
                </td>
                <td>
                  <b-form-select
                    v-model="dropOut[i]"
                    :options="ynOptions"
                    v-if="student.hasFormData"
                  ></b-form-select>
                </td>
                <td>
                  <b-form-select
                    v-model="heldBack[i]"
                    v-if="student.hasFormData"
                    :options="ynOptions"
                  ></b-form-select>
                </td>
                <td>
                  <input
                    v-if="student.hasFormData"
                    type="text"
                    v-model="addNotes[i]"
                  />
                </td>
              </tr>
            </table>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <table class="form-table">
              <tr>
                <th v-for="header in tableHeadersII" :key="header">
                  {{ header }}
                </th>
              </tr>
              <tr
                v-for="(student, i) in schoolStudents"
                :key="i"
                :class="{ disabled: !student.hasFormData }"
              >
                <td>
                  <b-link
                    @click.stop="stopClick"
                    :to="{
                      name: 'EditStudent',
                      params: { id: student.student_uuid },
                    }"
                  >
                    {{ student.first_name }} {{ student.last_name }}
                  </b-link>
                </td>
                <td>
                  <input
                    v-if="student.hasFormData"
                    type="number"
                    v-model="maths[i]"
                  />
                </td>
                <td>
                  <input
                    v-if="student.hasFormData"
                    type="number"
                    v-model="english[i]"
                  />
                </td>
                <td>
                  <input
                    v-if="student.hasFormData"
                    type="number"
                    v-model="art[i]"
                  />
                </td>
                <td>
                  <input
                    v-if="student.hasFormData"
                    type="number"
                    v-model="overall[i]"
                  />
                </td>
                <td>
                  <input
                    v-if="student.hasFormData"
                    type="number"
                    v-model="posInClass[i]"
                  />
                </td>
                <td>
                  <input
                    v-if="student.hasFormData"
                    type="number"
                    v-model="noOnRole[i]"
                  />
                </td>
              </tr>
            </table>
          </b-col>
        </b-row>
        <br />
        <br />
        <b-row>
          <b-col>
            <b-form-group
              label="Grade/Class: "
              label-cols-md="auto"
              class="mb-3"
            >
              <b-form-input v-model="grade"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group
              label="Number of Pupils in Class: "
              label-cols-md="auto"
              class="mb-3"
            >
              <b-form-input v-model="noPupils"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              label="Class Teacher Name: "
              label-cols-md="auto"
              class="mb-3"
            >
              <b-form-input v-model="teacherName"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group
              label="Class Teacher Signed? "
              label-cols-md="auto"
              class="mb-3"
            >
              <b-form-select
                v-model="teacherSigned"
                :options="ynOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              label="Head Teacher Name: "
              label-cols-md="auto"
              class="mb-3"
            >
              <b-form-input v-model="headTeacherName"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group
              label="Head Teacher Signed? "
              label-cols-md="auto"
              class="mb-3"
            >
              <b-form-select
                v-model="headTeacherSigned"
                :options="ynOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button
              :size="'lg'"
              :variant="'primary'"
              class="app_school_btn mb-4"
              @click.prevent="saveForm"
              >Save Form</b-button
            >
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <b-row>
          <b-col>
            <p>
              There are no students registered at the school starting in
              {{ startYear }}
            </p>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PrimarySchoolService from "../services/PrimarySchoolService";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";

export default {
  name: "MEFormInput",
  mixins: [flash, scrollTo],
  components: {},
  data() {
    return {
      schoolId: this.$route.params.id ? this.$route.params.id : null,
      isDisabled: true,
      tableHeadersI: [
        "",
        "Student Name",
        "Date of Birth",
        "Attendance (%)",
        "Dropped Out? (Y/N)",
        "Held Back? (Y/N)",
        "Additional Notes",
      ],
      tableHeadersII: [
        "Student Name",
        "Maths Score (%)",
        "English Score (%)",
        "Art Score (%)",
        "Overall Score (%)",
        "Position in Class (rank)",
        "Number on Role",
      ],
      errorMessage: "",
      formDate: "",
      showForm: true,
      startYear: new Date().getFullYear(),
      teacherName: "",
      teacherSigned: null,
      headTeacherName: "",
      headTeacherSigned: null,
      grade: "",
      noPupils: null,
      ynOptions: [
        { value: true, text: "Yes" },
        { value: false, text: "No" },
      ],
      loadingStudents: false,
      trainerUuid: "",
      attendance: [],
      dropOut: [],
      heldBack: [],
      addNotes: [],
      maths: [],
      english: [],
      art: [],
      overall: [],
      posInClass: [],
      noOnRole: [],
    };
  },
  methods: {
    ...mapActions({
      GET_SCHOOL_STUDENTS: "primarySchools/GET_SCHOOL_STUDENTS",
      GET_SCHOOL_TRAINERS: "primarySchools/GET_SCHOOL_TRAINERS",
      RESET_SCHOOLS_STATE: "primarySchools/RESET_SCHOOLS_STATE",
    }),
    toggleForm() {
      this.showForm = !this.showForm;
    },
    async saveForm() {
      if (this.checkFormData()) {
        const formData = [];
        this.schoolStudents.forEach((student, i) => {
          if (student.hasFormData) {
            let data = {};
            data.student_uuid = student.student_uuid;
            data.date = this.formDate;
            data.attendance = this.attendance[i];
            data.drop_out = this.dropOut[i];
            data.score_maths = this.maths[i];
            data.score_english = this.english[i];
            data.score_art = this.art[i];
            data.score_overall = this.overall[i];
            data.rank_in_class = this.posInClass[i];
            data.number_on_role = this.noOnRole[i];
            data.held_back = this.heldBack[i];
            data.additional_notes = this.addNotes[i];
            data.school_uuid = this.schoolId;
            data.teacher_name = this.teacherName;
            data.teacher_signed = this.teacherSigned;
            data.head_teacher_name = this.headTeacherName;
            data.head_teacher_signed = this.headTeacherSigned;
            data.grade = this.grade;
            data.number_pupils_in_class = this.noPupils;
            data.trainer_uuid = this.trainerUuid;
            formData.push(data);
          }
        });

        const reply = await PrimarySchoolService.addStudentMEForm(formData);

        if (reply.status == 200) {
          this.flashSuccess();
          this.resetData();
        } else {
          this.errorMessage = "There was an error saving form data";
          this.flashError();
        }
      } else {
        this.errorMessage = "Please fill all fields before saving";
        this.flashError();
      }
    },
    checkFormData() {
      let result = true;
      result = this.formDate != null ? true : false;
      result = this.trainerUuid != null ? true : false;
      result = this.grade != null ? true : false;
      result = this.noPupils != null ? true : false;
      result = this.teacherName != null ? true : false;
      result = this.headTeacherName != null ? true : false;
      result = this.headTeacherSigned != null ? true : false;
      result = this.teacherSigned != null ? true : false;

      return result;
    },
    resetData() {
      const len = this.schoolStudents.length;
      this.attendance = new Array(len);
      this.dropOut = new Array(len);
      this.heldBack = new Array(len);
      this.addNotes = new Array(len);
      this.maths = new Array(len);
      this.english = new Array(len);
      this.art = new Array(len);
      this.overall = new Array(len);
      this.posInClass = new Array(len);
      this.noOnRole = new Array(len);
      this.teacherSigned = null;
      this.teacherName = "";
      this.headTeacherName = "";
      this.headTeacherSigned = null;
      this.formDate = null;
      this.trainerUuid = "";
      this.grade = "";
      this.noPupils = null;
    },
  },
  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin",
    }),
    years() {
      let years = [];
      let currYear = new Date().getFullYear();
      for (let year = currYear; year > 2000; year--) {
        years.push(year);
      }
      return years;
    },
    schoolStudents: {
      get() {
        const students = this.$store.state.primarySchools.schoolStudents;
        // students.forEach((student) => {
        //   student.hasFormData = true;
        // });
        return students;
      },
    },
    schoolTrainers: {
      get() {
        return this.$store.state.primarySchools.schoolTrainers;
      },
    },
    school: {
      get() {
        return this.$store.state.primarySchools.school;
      },
    },
  },
  watch: {
    // whenever question changes, this function will run
    startYear: async function () {
      this.loadingStudents = true;
      await this.GET_SCHOOL_STUDENTS(this.startYear);
      this.resetData();
      this.loadingStudents = false;
    },
  },
  async created() {
    this.loadingStudents = true;
    await this.GET_SCHOOL_STUDENTS(this.startYear);
    this.resetData();
    await this.GET_SCHOOL_TRAINERS();
    this.loadingStudents = false;
  },
};
</script>

<style scoped>
.add {
  color: green;
  font-weight: bold;
}

.small-date {
  font-style: italic;
  font-size: 10px;
  color: #5a6269;
}
.delete {
  color: #9f020f;
  font-weight: bold;
}

.form-table {
  table-layout: fixed;
  width: 100%;
  word-wrap: break-word;
}

.app_school_btn {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: 520px;
  border: none;
  cursor: pointer;
}

table,
th,
td {
  border: 1px solid black;
}

.disabled {
  background-color: grey;
}

input {
  table-layout: fixed;
  width: 100%;
}
</style>
